import { User, UserData, UserProfile } from 'APIs/letrusAPI/user/types';

const STORAGE_KEY = 'teacherData';

export function getUserData() {
  const userData: UserData | undefined = JSON.parse(
    localStorage.getItem(STORAGE_KEY) || 'null'
  );

  return {
    user: userData?.user,
    userRole: userData?.user_roles?.[0],
    userRoleList: userData?.user_roles,
    userProfile: userData?.user?.user_profile,
  };
}

export function updateLocalUserProfile(newProfile: UserProfile) {
  const storedUserData = localStorage.getItem(STORAGE_KEY);

  if (!storedUserData) return;

  const userData = JSON.parse(storedUserData);

  setUserData({
    ...userData,
    user: { ...userData.user, user_profile: newProfile },
  });
}

export function updateLocalUser(newUser: User) {
  const storedUserData = localStorage.getItem(STORAGE_KEY);

  if (!storedUserData) return;

  const userData = JSON.parse(storedUserData);

  setUserData({ ...userData, user: newUser });
}

export function setUserData(userData: UserData) {
  if (typeof userData === 'object' && userData !== null) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
  }
}
